import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderMobileUserLoginMenu = () => openPopupHelper({ popupName: popupNames.MOBILE_USER_LOGIN_MENU });
